"use client";

import { c as _c } from "react/compiler-runtime";
import { MessagingAndroid } from "./android";
import { MessagingIos } from "./ios";
import { useThemeStore } from "@/store/theme-store";
import { MessagingWeb } from "./web";
const platformComponents = {
  ios: MessagingIos,
  android: MessagingAndroid,
  web: MessagingWeb
};
export const Messaging = () => {
  const $ = _c(2);
  const platform = useThemeStore(_temp);
  const Component = platformComponents[platform];
  let t0;
  if ($[0] !== Component) {
    t0 = <Component className="h-full w-full" />;
    $[0] = Component;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(state) {
  return state.platform;
}